import React, { useState, useEffect } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// 8 variations of organizational intelligence messages
const SUPERBUCKET_MESSAGES = [
  'Analyzing organizational intelligence',
  'Querying company knowledge base',
  'Processing institutional memory',
  'Accessing organizational insights',
  'Searching corporate intelligence',
  'Mining organizational data',
  'Exploring company knowledge',
  'Retrieving organizational context'
];

// SuperBucket Loading Indicator Component
const SuperBucketIndicator = ({ darkMode }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [currentMessage, setCurrentMessage] = useState(SUPERBUCKET_MESSAGES[0]);

  // Rotate through messages every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % SUPERBUCKET_MESSAGES.length;
        setCurrentMessage(SUPERBUCKET_MESSAGES[nextIndex]);
        return nextIndex;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  // Calculate text width dynamically based on message length
  const getTextWidth = (text) => {
    // Approximate width calculation: 8px per character + some padding
    return Math.max(text.length * 8 + 20, 200);
  };

  const textWidth = getTextWidth(currentMessage);
  
  return (
    <div className="pb-4">
      {/* SuperBucket text with mask-based shimmer effect */}
      <div>
        <SkeletonTheme 
          baseColor={darkMode ? "#666666" : "#999999"} 
          highlightColor={darkMode ? "#ffffff" : "#ffffff"}
        >
          <div 
            style={{
              width: `${textWidth}px`,
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              marginTop: '5px',
              marginBottom: '12px'
            }}
          >
            <div
              style={{
                width: `${textWidth}px`,
                height: '16px',
                maskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                  <svg width="${textWidth}" height="16" viewBox="0 0 ${textWidth} 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="14" fill="black">${currentMessage}</text>
                  </svg>
                `)}")`,
                WebkitMaskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                  <svg width="${textWidth}" height="16" viewBox="0 0 ${textWidth} 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="14" fill="black">${currentMessage}</text>
                  </svg>
                `)}")`,
                maskSize: 'contain',
                WebkitMaskSize: 'contain',
                maskRepeat: 'no-repeat',
                WebkitMaskRepeat: 'no-repeat',
                maskPosition: 'left center',
                WebkitMaskPosition: 'left center'
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <Skeleton 
                  height="16px" 
                  width="100%"
                  style={{ 
                    display: 'block',
                    lineHeight: 1
                  }}
                />
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </div>
    </div>
  );
};

export default SuperBucketIndicator;
